import { ColumnDef } from '@tanstack/react-table'
import { GetDailyPlayerReturnLossResponseData } from '@/modules/promotion/type'
import { format } from 'date-fns'
import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'

export const columns: ColumnDef<GetDailyPlayerReturnLossResponseData>[] = [
	{
		accessorKey: 'playerPhone',
		header: 'ผู้เล่น/วันที่',
		cell: ({ row }) => (
			<div className="space-y-1">
				<p>{row.original.playerPhone || '-'}</p>
				<p className="text-xs text-muted-foreground">
					วันที่: {format(new Date(row.original.date), 'dd/MM/yyyy')}
				</p>
			</div>
		),
	},
	{
		accessorKey: 'totalSlotLossAmount',
		header: 'ยอดเสียสล็อต',
		cell: ({ row }) => row.original.totalSlotLossAmount.toLocaleString(),
	},
	{
		accessorKey: 'totalCasinoLossAmount',
		header: 'ยอดเสียคาสิโน',
		cell: ({ row }) => row.original.totalCasinoLossAmount.toLocaleString(),
	},
	{
		accessorKey: 'totalLottoLossAmount',
		header: 'ยอดเสียหวย',
		cell: ({ row }) => row.original.totalLottoLossAmount.toLocaleString(),
	},
	{
		accessorKey: 'totalSportLossAmount',
		header: 'ยอดเสียกีฬา',
		cell: ({ row }) => row.original.totalSportLossAmount.toLocaleString(),
	},
	{
		accessorKey: 'totalFishingLossAmount',
		header: 'ยอดเสียยิงปลา',
		cell: ({ row }) => row.original.totalFishingLossAmount.toLocaleString(),
	},
	{
		accessorKey: 'returnLossRewardedAt',
		header: 'เวลาการรับรางวัล',
		cell: ({ row }) => (
			<div className="space-y-1 text-xs">
				<p>
					ผู้เล่นรับ:{' '}
					{row.original.returnLossRewardedAt
						? format(
								new Date(row.original.returnLossRewardedAt),
								'dd/MM/yyyy HH:mm',
							)
						: '-'}
				</p>
				<p className="text-muted-foreground">
					ผู้ชวนรับ:{' '}
					{row.original.inviteFriendReturnLossRewardedAt
						? format(
								new Date(row.original.inviteFriendReturnLossRewardedAt),
								'dd/MM/yyyy HH:mm',
							)
						: '-'}
				</p>
			</div>
		),
	},
	{
		id: 'details',
		header: 'การดำเนินการ',
		cell: ({ row }) => (
			<Button asChild variant="outline">
				<Link
					to={`/operator/get-player-list/player-detail/${row.original.playerId}`}
				>
					ดูรายละเอียด
				</Link>
			</Button>
		),
	},
]
